'use strict';

var layers = L.featureGroup();
var setLatlon = function setLatlon() {
    var mapBounds = map.getBounds();
    var left = mapBounds._southWest.lng,
        bottom = mapBounds._southWest.lat,
        top = mapBounds._northEast.lat,
        right = mapBounds._northEast.lng;

    var mapHeight = top - bottom,
        mapWidth = right - left;
    var num = void 0;
    var screen = $('#zmap').width();
    if (screen >= 768 && screen <= 1024) {
        num = 4;
    } else if (screen > 1024) {
        num = 8;
    } else {
        num = 3;
    }

    var lonGrid = mapWidth / num,
        latGrid = lonGrid;

    var opts = {
        color: '#aaa',
        weight: 1
    };

    for (var i = 1; i <= num - 1; i++) {
        var pointLat = left + lonGrid * i;
        var bottomPoint = [bottom, pointLat],
            topPoint = [top, pointLat];
        var latlngs = [bottomPoint, topPoint];
        var polyline = L.polyline(latlngs, opts);
        polyline.id = 'latlngLine';
        layers.addLayer(polyline);

        if (pointLat > 180) {
            var remainder = Math.ceil((pointLat - 180) / 360);
            pointLat -= remainder * 360;
        } else if (pointLat < -180) {
            var _remainder = Math.floor((pointLat + 180) / 360);
            pointLat -= _remainder * 360;
        }

        var obj = {
            html: '<span class="ponitLatlon">' + Math.abs(pointLat.toFixed(2)) + (pointLat > 0 ? 'E' : 'W') + '</span>'
        };
        var topDivIcon = L.marker(topPoint, {
            icon: L.divIcon(Object.assign({}, obj, {
                iconAnchor: [-5, -5]
            }))
        });
        var bottomDivIcon = L.marker(bottomPoint, {
            icon: L.divIcon(Object.assign({}, obj, {
                iconAnchor: [-5, 20]
            }))
        });
        topDivIcon.id = 'latlngDivIcon';
        bottomDivIcon.id = 'latlngDivIcon';
        layers.addLayer(topDivIcon);
        layers.addLayer(bottomDivIcon);
    }

    var lonGridNum = mapHeight / latGrid;
    for (var _i = 1; _i <= lonGridNum; _i++) {
        var pointLon = top - lonGrid * _i;
        var leftPoint = [pointLon, left],
            rightPoint = [pointLon, right];
        var _latlngs = [leftPoint, rightPoint];
        var _polyline = L.polyline(_latlngs, opts);
        _polyline.id = 'latlngLine';
        layers.addLayer(_polyline);

        var _obj = {
            html: '<span class="ponitLatlon">' + pointLon.toFixed(2) + (pointLon > 0 ? 'N' : 'S') + '</span>'
        };
        var leftDivIcon = L.marker(leftPoint, {
            icon: L.divIcon(Object.assign({}, _obj, {
                iconAnchor: [-5, 20]
            }))
        });
        var rightDivIcon = L.marker(rightPoint, {
            icon: L.divIcon(Object.assign({}, _obj, {
                iconAnchor: [40, 20]
            }))
        });
        leftDivIcon.id = 'latlngDivIcon';
        rightDivIcon.id = 'latlngDivIcon';
        layers.addLayer(leftDivIcon);
        layers.addLayer(rightDivIcon);
    }

    layers.addTo(map).bringToBack();
};
setLatlon();
var resetLonlat = function resetLonlat() {
    map.removeLayer(layers);
    layers = L.featureGroup();
    setLatlon();
};
map.on('moveend', resetLonlat);


//////////////////
// WEBPACK FOOTER
// ./js/latlon.js
// module id = 16
// module chunks = 0